export const calcValueOnTouch = (container, e, length) => {
    const { width, left } = container.getBoundingClientRect();
    const touch = e.touches[0] || e.changedTouches[0];
    const halfStarWidth = width / (length * 2);
    let cordsArr = [];
    for (let index = 0; index < 10; index++) {
        cordsArr.push(left + halfStarWidth * index);
    }
    const selectedStar = cordsArr.findIndex((cord, i) => {
        return touch.pageX > cord && (!cordsArr[i + 1] || touch.pageX < cordsArr[i + 1]);
    });

    return selectedStar / 2 + 0.5;
};
